// extracted by mini-css-extract-plugin
module.exports = {"NextArrow":"Arrows_NextArrow__3-_Ew","PrevArrow":"Arrows_PrevArrow__1E71g","arrowWrapper":"Arrows_arrowWrapper__3DaSl"};